/** @jsx jsx */
import { useState, useEffect } from "react";
import { css, jsx } from "@emotion/react";
import theWrapVideo from "../../../images/Banner_thewrap.mp4";
import theMobileWrapVideo from '../../../images/Banner_thewrap_mobile.mp4';

const WrapHeaderSection = ({ props }) => {

  const [width, setWidth] = useState(null);
  const handleWindowSizeChange = () => setWidth(window?.innerWidth);
  useEffect(() => {
    setWidth(window?.innerWidth) ;
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  let url = (width && width <= 768) ? theMobileWrapVideo : theWrapVideo;

  return (
    <div
      css={css`
        width: 100%;
        position: relative;
        background-color: #f7c87a;
        margin-top: -3rem;
        text-align: center;
    `}
    >
      <video
        css={css`
            width: 100%;
        `}
        src={`${url}#t=0.001`}
        alt="The Wrap Mural Video"
        autoPlay="autoplay"
        playsInline
        muted="muted"
        loop />
    </div>
  );
};

export default WrapHeaderSection;
